export default __webpack_public_path__ + "static/media/sub_page_exhibitor_en.fe95439d.svg";